export default __webpack_public_path__ + "1067e4f544573a808db9cf39397e3b8e.svg";